<div class="timesheet-row">
    <div class="timesheet-row__times">
        <pace-instant-field
            [formField]="entry().start"
            [minInstant]="minInstant()"
            [dateAriaLabel]="'TIMESHEET_MANUAL_START_DATE_LABEL' | translate"
            [timeAriaLabel]="'TIMESHEET_MANUAL_START_TIME_LABEL' | translate"
        ></pace-instant-field>
        <pace-instant-field
            class="d-block mt-2"
            [formField]="entry().end"
            [maxInstant]="maxInstant()"
            [dateAriaLabel]="'TIMESHEET_MANUAL_END_DATE_LABEL' | translate"
            [timeAriaLabel]="'TIMESHEET_MANUAL_END_TIME_LABEL' | translate"
        ></pace-instant-field>
    </div>

    <div class="timesheet-row__duration">{{ duration() }}</div>

    <div class="timesheet-row__activity">
        @if (isTravel()) {
            <label class="form-control-plaintext" translate="TIMESHEET_TRAVEL_BACK"></label>
        } @else {
            <pace-select-field
                [formField]="entry().taskType"
                [options]="taskTypeOptionsFiltered()"
                [placeholder]="'TIMESHEET_SELECT_ADDRESS_LABEL' | translate"
                [ariaLabel]="'TIMESHEET_TABLE_ACTIVITY_LABEL' | translate"
            ></pace-select-field>
        }
    </div>

    <div class="timesheet-row__meta">
        @if (displayAddress()) {
            <button
                class="btn address-btn"
                type="button"
                [class.btn-secondary]="!addressMissing()"
                [class.btn-danger]="addressMissing()"
                (click)="selectAddress.emit()"
                [attr.aria-label]="'TIMESHEET_LAUNCH_SELECT_ADDRESS_MODAL_LABEL' | translate"
                [disabled]="!editable()"
            >
                @if (addressMissing()) {
                    {{ 'TIMESHEET_ADDRESS_LABEL' | translate }}
                } @else {
                    {{ addressLabel() }}
                }
            </button>
        }
    </div>

    <div class="timesheet-row__actions">
        @if (editable()) {
            <button
                class="btn btn-warning"
                type="button"
                (click)="deleteEntry.emit()"
                [attr.aria-label]="'TIMESHEET_DELETE_MANUAL_ENTRY_LABEL' | translate"
            >
                <fa-icon [icon]="faTrashAlt"></fa-icon>
            </button>
        }
    </div>
</div>
